import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col, Toast } from "react-bootstrap";
import CustomButton from "../../common-components/button/Button.jsx";
import InputField from "../../common-components/input-field/Input-field.jsx";
import { changePassword } from "../../state/reducers/changePassword.js";

function ChangePassword() {
  const [username, setUsername] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [validationMessages, setValidationMessages] = useState({});
  const [showToast, setShowToast] = useState(false);

  const dispatch = useDispatch();
  const { loading, error, success, message } = useSelector((state) => state.changePassword);

  useEffect(() => {
    // Retrieve username from local storage
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setUsername(parsedUser.username || "");
    }
  }, []);
  
  useEffect(() => {
    if (success && message) {
      setShowToast(true);
      // Reset form after successful password change
      //setUsername("");
      setOldPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } else if(message) {
      setShowToast(true)
      setOldPassword("");
      setNewPassword("");
      setConfirmPassword("");
    }
  }, [success, message]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = {};

    //if (!username) validationErrors.username = "Username is required";
    if (!oldPassword) validationErrors.oldPassword = "Old password is required";
    if (!newPassword) validationErrors.newPassword = "New password is required";
    if (!confirmPassword) validationErrors.confirmPassword = "Confirm password is required";
    if (newPassword !== confirmPassword) validationErrors.confirmPassword = "Passwords do not match";

    if (Object.keys(validationErrors).length > 0) {
      setValidationMessages(validationErrors);
      return;
    }

    dispatch(changePassword({
      username,
      old_password: oldPassword,
      new_password: newPassword
    }));
  };

  return (
    <div className="page-wrapper login-page change-password-page">
      <Container>
        <Row className="justify-content-center">
          <Col md={5}>
            <div className="change-password-panel login-panel justify-content-center">
              <h3 className="text-center mb-3">Change Password</h3>
              <form className="change-password-form login-form" onSubmit={handleSubmit}>
                <input type="hidden" name="username" value={username} />
                {/* <Row className="mb-3">
                  <Col xs={12}>
                    <InputField
                      key='username'
                      type="text"
                      label="Username"
                      name="username"
                      id='username'
                      value={username}
                      disabled={true}
                      layoutStyle="vertical"
                      placeholder="Enter your username"
                      required
                      validationMsg={validationMessages.username}
                    />
                  </Col>
                </Row> */}

                <Row className="mb-3">
                  <Col xs={12}>
                    <InputField
                      key='oldPassword'
                      type="password"
                      label="Old Password"
                      name="oldPassword"
                      id='oldPassword'
                      value={oldPassword}
                      onChange={(e) => setOldPassword(e.target.value)}
                      layoutStyle="vertical"
                      placeholder="Enter your old password"
                      required
                      validationMsg={validationMessages.oldPassword}
                    />
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col xs={12}>
                    <InputField
                      key='newPassword'
                      type="password"
                      label="New Password"
                      name="newPassword"
                      id='newPassword'
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      layoutStyle="vertical"
                      placeholder="Enter your new password"
                      required
                      validationMsg={validationMessages.newPassword}
                    />
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col xs={12}>
                    <InputField
                      key='confirmPassword'
                      type="password"
                      label="Confirm Password"
                      name="confirmPassword"
                      id='confirmPassword'
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      layoutStyle="vertical"
                      placeholder="Confirm your new password"
                      required
                      validationMsg={validationMessages.confirmPassword}
                    />
                  </Col>
                </Row>

                {error && (
                  <Row className="mb-3">
                    <Col xs={12}>
                      <div className="text-danger">{error}</div>
                    </Col>
                  </Row>
                )}

                <Row className="justify-content-center">
                  <Col xs="auto">
                    <CustomButton 
                      label={loading ? "Changing Password..." : "Change Password"}
                      type="submit"
                      disabled={loading}
                      className="login-btn" 
                      onClick= {handleSubmit}
                    />
                  </Col>
                </Row>
              </form>
            </div>
          </Col>
        </Row>

        <Toast
          show={showToast}
          onClose={() => setShowToast(false)}
          delay={3000}
          autohide
          style={{
            position: "fixed",
            top: 20,
            right: 20,
            minWidth: 200
          }}
        >
          <Toast.Header>
            {success && <strong className="mr-auto">Success</strong>}
          </Toast.Header>
          <Toast.Body>{message}</Toast.Body>
        </Toast>
      </Container>
    </div>
  );
}

export default ChangePassword;